// keep identical in app and live
export default [23, 16, 10, 8];
